import PanelCloseButton from '../panelHeader/panelCloseButton';

export default function PanelFallbackView() {
  return (
    <div className="sidebar-scroll-panel sidebar-panel-default-appearance">
      <div className="sidebar-panel-header u-clr-grey7">
        <h2 className="sidebar-panel-header-title text-s u-clr-grey7">Something went wrong...</h2>
        <PanelCloseButton />
      </div>
    </div>
  );
}
